import React, {useEffect, useState } from 'react';
import { ComponentService } from '../../../api';
import { ISelectOptions } from "react-ocean-forms-bootstrap";
import { TBasicFieldValue, IBaseFieldProps, IValidatedComponentProps } from 'react-ocean-forms';
import { Select } from '../../../framework';

interface BaseKomponententypSelectProps {
  onSelect(event: TBasicFieldValue): void;
}

type KomponententypSelectProps = BaseKomponententypSelectProps & IBaseFieldProps & IValidatedComponentProps;

/**
 * @author Jungwirth
 * TODO: add value to set default value 
 */
export const KomponententypSelect: React.FC<KomponententypSelectProps> = (props: Readonly<KomponententypSelectProps>): JSX.Element => {
  const { value, onSelect, name, label, plaintext, disabled, validators } = props;
  const [data, setData] = useState<ISelectOptions>([]);
  const [isLoading, setIsLoading] = useState(false);

  // https://github.com/JedWatson/react-select/issues/3066
  const selectValue = value ? value : null;

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      setIsLoading(true);
      const result = await ComponentService.findAllComponentTypeOptions();
      setData(result);
      setIsLoading(false);
    };
    fetchData();
  },[]);
  return (
    <div id="komponententyplist">
      <Select
        loading={isLoading}
        name={name}
        label={label}
        disabled={disabled}
        plaintext={plaintext}
        validators={validators}
        options={data}
        onChange={onSelect}
        //@ts-ignore
        value={selectValue}
        labelSize="6"
        
        inputSize="6"
      />
    </div>
  );
};
